import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { Button, ButtonGroup, Container } from "@mui/material";
import { addVehicle } from "../../redux/vehicle/action";
import { useDispatch, useSelector } from "react-redux";
import CustomLoader from "../../components/CustomLoader";
import "./styles.css";
import AddTruckForm from "../../components/forms/AddTruckForm";
import AddTrailerkForm from "../../components/forms/AddTrailerkForm";
import AddPersonalVehicalForm from "../../components/forms/AddPersonalVehicalForm";
import { enqueueSnackbar } from "notistack";
import { useResponsive } from "../../hooks/useResponsive";
import storePersist, { localConstant } from "../../services/localStorage";
import SnackbarConfig from "../../utils/snackbarConfig";
import NavBar from "../../NavBar";
import { useTranslation } from "react-i18next";

const AddVehicles = ({
  enableNav = true,
  isDialog = false,
  resetDialog = () => {},
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const smDown = useResponsive("down", "sm");
  // const { isLoading } = useSelector((state) => state.vehicleReducer);
  const [isLoading, setIsLoading] = useState(false);
  const { current } = useSelector((state) => state.loginReducer);
  const [vehicleType, setVehicleType] = useState("TRUCK");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [uploadedLicensePlate, setUploadedLicensePlate] = useState(null);
  const [uploadedInsurance, setUploadedInsurance] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  // It will remove the error message when user changes the tab.
  useEffect(() => {
    setErrorMessage("");
  }, [vehicleType]);

  const submitForm = (values, isSaveButton) => {
    values.cust_id = current?.entity_customer_id
      ? current.entity_customer_id
      : storePersist.get(localConstant.ENTITY_CUSTOMER_ID);
    values.veh_type_cd = vehicleType.toString();
    values.ct_user = `${current?.entity_first_name} ${current?.entity_last_name}`;
    let fileInfoArray = [];
    if (uploadedImage) {
      fileInfoArray.push({
        name: "file0",
        mediaType: uploadedImage
          ? uploadedImage?.type === "application/pdf"
            ? "PDF"
            : uploadedImage?.type
          : "",
        mediaCode: vehicleType === "TRUCK" ? "VEHCLPIC" : "LICPL",
        mediaObj: uploadedImage,
      });
    }
    if (uploadedLicensePlate) {
      fileInfoArray.push({
        name: "file1",
        mediaType: uploadedLicensePlate
          ? uploadedLicensePlate?.type === "application/pdf"
            ? "PDF"
            : uploadedLicensePlate?.type
          : "",
        mediaCode: "LICPL",
        mediaObj: uploadedLicensePlate,
      });
    }
    if (uploadedInsurance) {
      fileInfoArray.push({
        name: "file2",
        mediaType:
          uploadedInsurance?.type === "application/pdf"
            ? "PDF"
            : uploadedInsurance?.type,
        mediaCode: "PROOFINS",
        mediaObj: uploadedInsurance,
      });
    }
    values.fileInfosArray = fileInfoArray;
    setIsLoading(true);
    dispatch(
      addVehicle(
        values,
        uploadedImage,
        uploadedLicensePlate,
        (addVehicleresponse) => {
          setIsLoading(false);
          if (addVehicleresponse?.customerVehicleId) {
            enqueueSnackbar(t("pages.addVehicle.text15"), {
              variant: "success",
              autoHideDuration: 3000,
              action: SnackbarConfig,
            });
            if (isSaveButton) {
              navigate("/vehiclesList");
              if (isDialog) {
                resetDialog();
                window.location.reload();
              }
            }

            setUploadedImage(null);
          } else {
            if (addVehicleresponse?.response?.data?.errorMessage) {
              setErrorMessage(
                `${addVehicleresponse?.response?.data?.errorMessage} ${addVehicleresponse?.response?.data?.lic_plate_num}`,
              );
              enqueueSnackbar(
                addVehicleresponse?.response?.data?.errorMessage,
                {
                  variant: "error",
                  autoHideDuration: 3000,
                  action: SnackbarConfig,
                },
              );
            } else {
              setErrorMessage(t("pages.addVehicle.text16"));
              enqueueSnackbar(t("pages.addVehicle.text16"), {
                variant: "error",
                autoHideDuration: 3000,
                action: SnackbarConfig,
              });
            }
          }
        },
      ),
    );
  };
  const handleLicensePlateFileUploadChange = (e) => {
    setUploadedLicensePlate(e.target.files[0]);
  };
  const handleLicenseFileUploadClick = (e) => {
    e.target.value = null;
  };

  const handleLicenseFileRemoveFile = () => {
    setUploadedLicensePlate(null);
  };
  const handleFileUploadChange = (e) => {
    setUploadedImage(e.target.files[0]);
  };
  const handleInsuranceFileUploadChange = (e) => {
    setUploadedInsurance(e.target.files[0]);
  };

  const handleInsuranceFileUploadClick = (e) => {
    e.target.value = null;
  };

  const handleInsuranceRemoveFile = () => {
    setUploadedInsurance(null);
  };

  const handleFileUploadClick = (e) => {
    e.target.value = null;
  };

  const handleRemoveFile = () => {
    setUploadedImage(null);
  };

  const renderAddVehicleForm = (
    <Stack spacing={2}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Typography
          fontWeight="bold"
          variant="customLable"
          color="common.inputCustomLable"
          marginBottom={1}
        >
          {t("pages.addVehicle.text01")}{" "}
          <span style={{ color: "#C50F1F" }}>*</span>
        </Typography>
        <ButtonGroup
          variant="outlined"
          aria-label="text button group"
          fullWidth
          size="large"
        >
          <Button
            style={{
              backgroundColor: vehicleType === "TRUCK" ? "#1D5AB9" : "#fff",
              borderColor: "#8A8886",
              borderWidth: 1,
            }}
            tabIndex={11}
            onClick={() => {
              setVehicleType("TRUCK");
            }}
            size="medium"
          >
            <Typography
              style={{
                fontFamily: "Segoe UI",
                fontSize: 12,
                fontWeight: 600,
                lineHeight: 16,
                color: vehicleType === "TRUCK" ? "#fff" : "#8A8886",
              }}
            >
              {t("pages.editVehicle.text02")}
            </Typography>
          </Button>
          <Button
            style={{
              backgroundColor: vehicleType === "TRALR" ? "#1D5AB9" : "#fff",
            }}
            tabIndex={12}
            onClick={() => {
              setVehicleType("TRALR");
              setUploadedImage(null);
            }}
            size="medium"
          >
            <Typography
              style={{
                fontFamily: "Segoe UI",
                fontSize: 12,
                fontWeight: 600,
                lineHeight: 16,
                color: vehicleType === "TRALR" ? "#fff" : "#8A8886",
              }}
            >
              {t("pages.editVehicle.text03")}
            </Typography>
          </Button>
          <Button
            style={{
              backgroundColor: vehicleType === "PERVEH" ? "#1D5AB9" : "#fff",
            }}
            tabIndex={13}
            onClick={() => {
              setVehicleType("PERVEH");
              setUploadedImage(null);
            }}
            size="large"
          >
            <Typography
              style={{
                fontFamily: "Segoe UI",
                fontSize: 12,
                fontWeight: 600,
                letterSpacing: "0px",
                color: vehicleType === "PERVEH" ? "#fff" : "#8A8886",
              }}
            >
              {t("pages.vehicleList.text02")}
            </Typography>
          </Button>
        </ButtonGroup>
      </Box>
      {vehicleType === "TRUCK" && (
        <AddTruckForm
          disableSubmit={isLoading}
          submitForm={(data, isSaveButton) => {
            if (!uploadedInsurance) {
              setErrorMessage("Please upload Insurance proof.");
              return;
            }
            submitForm(data, isSaveButton);
          }}
          setUploadedImage={setUploadedImage}
          uploadedImage={uploadedImage}
          handleFileUploadChange={handleFileUploadChange}
          handleFileUploadClick={handleFileUploadClick}
          handleRemoveFile={handleRemoveFile}
          uploadedLicensePlate={uploadedLicensePlate}
          setUploadedLicensePlate={setUploadedLicensePlate}
          handleLicensePlateFileUploadChange={
            handleLicensePlateFileUploadChange
          }
          handleLicenseFileUploadClick={handleLicenseFileUploadClick}
          handleLicenseRemoveFile={handleLicenseFileRemoveFile}
          uploadedInsurance={uploadedInsurance}
          handleInsuranceFileUploadChange={handleInsuranceFileUploadChange}
          handleInsuranceFileUploadClick={handleInsuranceFileUploadClick}
          handleInsuranceRemoveFile={handleInsuranceRemoveFile}
          errorMessage={errorMessage}
        />
      )}
      {vehicleType === "TRALR" && (
        <AddTrailerkForm
          disableSubmit={isLoading}
          submitForm={(data, isSaveButton) => {
            if (!uploadedInsurance) {
              setErrorMessage("Please upload Insurance proof.");
              return;
            }
            submitForm(data, isSaveButton);
          }}
          setUploadedImage={setUploadedImage}
          uploadedImage={uploadedImage}
          handleFileUploadChange={handleFileUploadChange}
          handleFileUploadClick={handleFileUploadClick}
          handleRemoveFile={handleRemoveFile}
          uploadedInsurance={uploadedInsurance}
          handleInsuranceFileUploadChange={handleInsuranceFileUploadChange}
          handleInsuranceFileUploadClick={handleInsuranceFileUploadClick}
          handleInsuranceRemoveFile={handleInsuranceRemoveFile}
          errorMessage={errorMessage}
        />
      )}
      {vehicleType === "PERVEH" && (
        <AddPersonalVehicalForm
          disableSubmit={isLoading}
          submitForm={(data, isSaveButton) => {
            if (!uploadedInsurance) {
              setErrorMessage("Please upload Insurance proof.");
              return;
            }
            submitForm(data, isSaveButton);
          }}
          setUploadedImage={setUploadedImage}
          uploadedImage={uploadedImage}
          handleFileUploadChange={handleFileUploadChange}
          handleFileUploadClick={handleFileUploadClick}
          handleRemoveFile={handleRemoveFile}
          uploadedInsurance={uploadedInsurance}
          handleInsuranceFileUploadChange={handleInsuranceFileUploadChange}
          handleInsuranceFileUploadClick={handleInsuranceFileUploadClick}
          handleInsuranceRemoveFile={handleInsuranceRemoveFile}
          errorMessage={errorMessage}
        />
      )}
    </Stack>
  );

  return (
    <Container
      disableGutters
      maxWidth={false}
      style={{
        position: "relative",
        minHeight: !isDialog && "100vh",
        backgroundColor: "#fff",
        width: isDialog ? "100%" : "100vw",
        height: isDialog ? "auto" : "100%",
      }}
    >
      {enableNav && (
        <NavBar title={t("pages.addVehicle.pageHeading")} enableMenu={false} />
      )}
      <Box
        maxWidth="xs"
        sx={{
          height: 1,
          flexGrow: 1,
          minHeight: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ height: 1, width: 1, padding: 0 }}
        >
          <Card
            sx={{
              p: 3,
              width: 1,
              pb: 0,
              maxWidth: 600,
              height: smDown ? 1 : "auto",
              boxShadow: "none",
            }}
            className="form_container"
          >
            {renderAddVehicleForm}
          </Card>
        </Stack>
      </Box>

      {isLoading && <CustomLoader />}
    </Container>
  );
};

export default AddVehicles;
